// src/components/LanguageSwitcher.jsx — simple EN/FR toggle
import React from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const language = i18n.resolvedLanguage?.startsWith("fr") ? "fr" : "en";
  const changeLanguage = async (event) => {
    const nextLanguage = event.target.value;
    await i18n.changeLanguage(nextLanguage);
    localStorage.setItem("i18nextLng", nextLanguage);
  };

  return (
    <label className="inline-flex items-center gap-2 rounded-lg border border-gold-100 bg-white px-3 py-2 text-xs font-bold text-gold-700" title={t("common.chooseLanguage")}>
      <Languages size={14} />
      <select value={language} onChange={changeLanguage} aria-label={t("common.chooseLanguage")} className="bg-transparent outline-none">
        <option value="fr">FR</option>
        <option value="en">EN</option>
      </select>
    </label>
  );
};

export default LanguageSwitcher;
